import { Component } from "@angular/core";

@Component({
    selector: "button-toggle-storybook",
    templateUrl: "./button-toggle-storybook.component.html",
})
export class ButtonToggleStorybookComponent {}
